<script>
  import _ from 'lodash'
  import LinkApi from '@/services/Api/LinkApi'
  import { matchRegexp } from '@/validators'
  import { validationMixin } from 'vuelidate'

  export default {
    mixins: [validationMixin],
    data() {
      return {
        loading: false,
        not_enough: false,
        links: getLinkTypes(),
        link_types: Object.keys(getLinkTypes())
      }
    },

    created() {
      this.setLinkTypes()
    },

    validations() {
      var base_validation = {
        links: {}
      }

      this.link_types.forEach(type => {
        base_validation.links[type] = {
          matchRegexp: matchRegexp('https?:\\/\\/.+', 'i')
        }
      })

      return base_validation
    },

    methods: {
      setLinkTypes() {
        var player_link_types = _.map(this.user.player.links, 'type')

        this.link_types = this.link_types.filter(link => {
          return (
            link === 'other' ||
            player_link_types.indexOf(link.toUpperCase().replace('-', '_')) === -1
          )
        })
      },

      addLinks() {
        this.$v.$touch()

        if (this.$v.$error) {
          return
        }

        var links = []

        _.forEach(this.links, (value, key) => {
          if (value) {
            links.push({
              type: key.toUpperCase().replace('-', '_'),
              url: value
            })
          }
        })

        if (links.length) {
          LinkApi.postLinks(links)
            .then(links => {
              this.user.player.links = this.user.player.links.concat(links)
              this.close()
            })
        } else {
          this.close()
        }
      },

      close() {
        this.$store.commit('Modals/hide', 'social_links')
      }
    }
  }

  function getLinkTypes() {
    return {
      'twitter': null,
      'linkedin': null,
      'github': null,
      'codepen': null,
      'instagram': null,
      'dribbble': null,
      'behance': null,
      'tumblr': null,
      'youtube': null,
      'medium': null,
      'pinterest': null,
      'vimeo': null,
      'google-plus': null,
      'other': null
    }
  }
</script>

<template>
  <form class="Social-links-form modal-card" @submit.prevent="addLinks">
    <button class="delete is-medium" type="button" @click="$parent.$emit('close')"></button>

    <div class="modal-card-body">
      <figure class="Social-links-form_img">
        <img src="../../assets/img/pop_illustration_social.png">
      </figure>
      
      <h2 class="title is-size-6-touch" v-show="link_types.length">{{ $t('social_link_form.title') }}</h2>
      <h2 class="title is-size-6-touch" v-show="!link_types.length">{{ $t('social_link_form.title_empty') }}</h2>

      <p v-show="not_enough" class="notification is-info">
        {{ $t('social_link_form.not_enough', {nb: 2}) }}
      </p>

      <p v-show="loading">{{ $t('loading') }}</p>

      <div class="columns is-multiline" v-show="!loading">
        <div class="column is-half"
          v-for="type in link_types"
          :key="type">
          <p class="control has-icon">
            <input class="input"
              type="text"
              v-model="links[type]"
              :placeholder="type == 'other' ? $t('social_link_form.type_other') : type">
            <span class="icon is-small">
              <i class="fa" :class="'fa-' + (type == 'other' ? 'link' : type)"></i>
            </span>
          </p>
          <p class="help is-danger"
            v-show="$v.links[type].$error && !$v.links[type].matchRegexp"
            v-html="$t('validation.active_url')"></p>
        </div>
      </div>

      <p v-show="not_enough" class="notification is-info">
        {{ $t('social_link_form.not_enough', {nb: 2}) }}
      </p>
    </div>
    <footer class="modal-card-foot">
      <p v-show="!loading && link_types.length">
        <button class="button is-danger" type="submit">
          {{ $t('buttons.add_links') }}
        </button>
      </p>
    </footer>
  </form>
</template>

<style lang="scss">
  .Social-links-form {
    position: relative;
    max-height: 78%;
    max-width: 540px;
    text-align: center;

    .delete {
      position: absolute;
      top: pxToEm(20);
      right: pxToEm(20);
    }

    &_img {
      margin: -1.25rem -1.25rem 0.25rem;
    }

    .title {
      font-weight: 500;
    }

    .control.has-icon .icon {
      font-weight: 500;
      color: $grey-light;
    }

    .modal-card-foot {
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// ModalSocialLinks.vue?fbe0d1be